import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

import Scoring from 'modules/nps/components/Scoring'
import { NpsForm } from 'modules/nps/hooks/useNpsForm'
import { NpsWidgetVariant } from 'modules/nps/lib/types'

type Props = {
  productName: string
  variant?: NpsWidgetVariant
  onChange: (field: keyof NpsForm, value: NpsForm[typeof field]) => void
  values: NpsForm
  onSubmit: () => void
  isSubmitting: boolean
}

const SurveyBody = ({
  productName,
  variant = 'viridian',
  onChange,
  values,
  onSubmit,
  isSubmitting,
}: Props) => {
  const [feedbackShown, setFeedbackShown] = useState(false)

  return (
    <Box gap="s48">
      <Scoring
        label={i18n.t('nps.score.label', { productName })}
        variant={variant}
        onChange={(value) => {
          const score = value ? Number(value) : value
          onChange('scoring', score)
          setFeedbackShown(!!score)
        }}
      />
      {feedbackShown && (
        <Box gap="s24" alignItems="flexEnd">
          <TextArea
            label={i18n.t('nps.survey_page.text_area.label')}
            placeholder={i18n.t('nps.survey_page.text_area.placeholder')}
            value={String(values.feedback || '')}
            maxLength={250}
            onChange={(message) => {
              onChange('feedback', message)
            }}
          />
          <Button
            onClick={() => {
              onSubmit()
            }}
            loading={isSubmitting}
          >
            {i18n.t('nps.survey_page.button')}
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default SurveyBody
